export const ClockIcon = ({
    fill = '#000000',
    size = 10
}: {
    fill?: string
    size?: number
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 4 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.99992 13.1668C7.30111 13.1668 9.16659 11.3013 9.16659 9.00016C9.16659 6.69898 7.30111 4.8335 4.99992 4.8335C2.69873 4.8335 0.833252 6.69898 0.833252 9.00016C0.833252 11.3013 2.69873 13.1668 4.99992 13.1668Z"
            stroke={fill}
        />
        <path d="M4.44434 7.3335V9.8335L6.111 10.6668" stroke={fill} />
    </svg>
)
